import { addMethod, string, StringSchema } from 'yup'
import * as yup from 'yup'

import setupPasswordMethods from '~/utils/yupPassword'

setupPasswordMethods(yup)

addMethod(string, 'passwordConfirmation', function (
  this: StringSchema,
  message: string
) {
  return this.test('passwordConfirmation', message, function (value) {
    const { password } = this?.parent
    if (!value && !password) return true

    return value === password
  })
})

addMethod(string, 'phoneNumber', function (
  this: StringSchema,
  message: string
) {
  return this.test(
    'phoneNumber',
    message || 'Phone number is invalid',
    async (value: any = '') => {
      if (!value) return true

      const parsePhoneNumber = (await import('libphonenumber-js')).default

      if (!parsePhoneNumber(value, 'AU')?.isValid()) return null

      return !!value.toString().trim()
    }
  )
})

addMethod(string, 'validateDate', function (
  this: StringSchema,
  message: string
) {
  return this.test(
    'validateDate',
    message || 'Format is invalid',
    async (value: any) => {
      if (!value) return null

      const { DateTime } = await import('luxon')

      return DateTime.fromISO(value).isValid
    }
  )
})

addMethod(string, 'integer', function (this: StringSchema) {
  return this.matches(/^\d+$/, 'The field should have digits only')
})

addMethod(string, 'validateYoutubeLink', function (
  this: StringSchema,
  message: string
) {
  return this.test(
    'validateYoutubeLink',
    message || 'Youtube link is invalid',
    async (value: any) => {
      if (!value) return null
      const getVideoId = (await import('get-video-id')).default

      const { service } = getVideoId(value)

      return service === 'youtube'
    }
  )
})
